import Vue from 'vue';
import Chart from 'chart.js';
import { mapGetters } from 'vuex';
import HelpIcon from 'components/project/analysis/results/widgets/HelpIcon.vue';
import ChartUtils from 'src/utils/chart';
import Utils from 'src/utils/general';
import FormatUtils from 'src/utils/formatters';
export default Vue.extend({
    components: { HelpIcon },
    props: {
        'height': { type: Number, default: 600 },
        'numConcepts': { type: Number, default: 20 }
    },
    data() {
        return {
            variable: null,
            help: `<p>This chart displays the 20 top concepts in your data ordered by coverage. You can explore them further in the Storyboard visualisation</p>`,
            conceptSummarychart: null
        };
    },
    computed: {
        ...mapGetters([
            'currentModel'
        ]),
        dataset() {
            let returnData = { data: [], labels: [], colours: [] };
            // Compute the displayable segment datasets
            let coverageOrder = this.currentModel.sortedConcepts.slice(); // copy the array
            coverageOrder.sort((a, b) => b.coverage - a.coverage); // sort by coverage
            // Zip into a js object of arrays for display
            coverageOrder.forEach((val, idx) => {
                if (idx < 20) { // only push top 20 values
                    returnData.data.push(val.coverage * 100); // %
                    returnData.labels.push(val.name);
                    returnData.colours.push(this.currentModel.conceptColours[val.name]);
                }
            });
            return returnData;
        }
    },
    watch: {
        dataset() {
            this.$nextTick(() => {
                this.drawConceptSummaryChart();
            });
        }
    },
    mounted() {
        // Calculate chart heights
        let offsetHeight = this.$el.querySelector('.secondary.segment').offsetHeight;
        this.$el.querySelector('.segment.body').style.height = `${this.height - offsetHeight}px`;
        this.$el.querySelector('.chart-container').style.height = `${this.height - offsetHeight - 28}px`; // padding
        this.$nextTick(() => {
            this.drawConceptSummaryChart();
        });
    },
    methods: {
        number: FormatUtils.number,
        // Adjust the chart to use frequency or correlation.
        drawConceptSummaryChart() {
            if (this.conceptSummaryChart) {
                this.conceptSummaryChart.destroy();
            }
            if (!this.hasData) {
                return;
            }
            this.$nextTick(() => {
                let chartEl = this.getConceptSummaryChartEl();
                this.conceptSummaryChart = new Chart(chartEl.getContext('2d'), {
                    type: 'horizontalBar',
                    data: {
                        labels: this.dataset.labels,
                        datasets: [{
                                borderWidth: 0,
                                borderSkipped: 'bottom',
                                backgroundColor: this.dataset.colours,
                                barPercentage: 0.75,
                                maxBarThickness: 50,
                                data: this.dataset.data
                            }]
                    },
                    plugins: [ChartUtils.horizontalZeroCompensationPlugin],
                    options: {
                        responsive: true,
                        maintainAspectRatio: false,
                        legend: {
                            display: false
                        },
                        tooltips: {
                            callbacks: {
                                label: (tooltipItem, data) => `${ChartUtils.percentLabel(tooltipItem)}`
                            }
                        },
                        // On click, redirect to query page for selected concept
                        onClick: (event) => {
                            let el = this.conceptSummaryChart.getElementAtEvent(event);
                            if (el.length > 0) {
                                this.$router.push(Utils.generateQueryLink([{
                                        type: 'text',
                                        values: [this.dataset.labels[el[0]._index]],
                                        operator: 'includes'
                                    }]));
                            }
                        },
                        hover: {
                            onHover: (chart, el) => {
                                if (el.length > 0) {
                                    if (this.dataset.labels[el[0]._index]) {
                                        chartEl.style.cursor = 'pointer';
                                        return;
                                    }
                                }
                                chartEl.style.cursor = 'default';
                            }
                        },
                        scales: {
                            yAxes: [{
                                    display: true,
                                    drawBorder: false,
                                    gridLines: {
                                        display: false
                                    }
                                }],
                            xAxes: [{
                                    display: false,
                                    scaleLabel: {
                                        display: true,
                                        fontStyle: 'bold'
                                    },
                                    type: 'linear',
                                    gridLines: {
                                        display: false
                                    },
                                    ticks: {
                                        beginAtZero: true,
                                        callback: function (tickValue, index, ticks) {
                                            return;
                                        }
                                    }
                                }]
                        }
                    }
                });
            });
        },
        getConceptSummaryChartEl() {
            return this.$refs.conceptSummary;
        },
        hasData() {
            return this.dataset.data.length > 0;
        }
    }
});
